import { DEFAULT_CRITERIA } from 'consts/targetCriteria';

export type TargetCriteria = {
  greenTolerance: number;
  orangeTolerance: number;
  priority: { code: string; name: string };
};

export type PublisherTolerances = {
  greenTolerance: string;
  orangeTolerance: string;
  priority: string;
};

export const getPublisherDefaultCriteria = (publisherTolerances?: PublisherTolerances): TargetCriteria => {
  if (!publisherTolerances) {
    return DEFAULT_CRITERIA;
  }

  return {
    greenTolerance: parseFloat(publisherTolerances.greenTolerance) * 100,
    orangeTolerance: parseFloat(publisherTolerances.orangeTolerance) * 100,
    priority: {
      code: publisherTolerances.priority,
      name: publisherTolerances.priority,
    },
  };
};

export const isDefaultCriteria = (criteria: TargetCriteria): boolean => {
  return (
    criteria.greenTolerance === DEFAULT_CRITERIA.greenTolerance &&
    criteria.orangeTolerance === DEFAULT_CRITERIA.orangeTolerance &&
    criteria.priority.code === DEFAULT_CRITERIA.priority.code
  );
};

export const getEffectiveCriteria = (
  storedCriteria: Partial<TargetCriteria> | undefined,
  publisherCriteria: TargetCriteria,
): TargetCriteria => {
  if (!storedCriteria) {
    return publisherCriteria;
  }

  const currentCriteria: TargetCriteria = {
    greenTolerance: storedCriteria.greenTolerance ?? DEFAULT_CRITERIA.greenTolerance,
    orangeTolerance: storedCriteria.orangeTolerance ?? DEFAULT_CRITERIA.orangeTolerance,
    priority: storedCriteria.priority ?? DEFAULT_CRITERIA.priority,
  };

  if (isDefaultCriteria(currentCriteria)) {
    return publisherCriteria;
  }

  return currentCriteria;
};
